"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'planAndTaskList',
      apiModule: 'kpiSet',
      searchQuery: {
        srCode: '',
        srName: '',
        startTime: '',
        endTime: '',
        role: ''
      }
    };
  },
  computed: {
    domData: function domData() {
      return {
        srCode: {
          label: this.$t('sfe.pattenkpi.srId'),
          valueKey: 'srCode'
        },
        srName: {
          label: this.$t('sfe.pattenkpi.srName'),
          valueKey: 'srName'
        },
        timeRange: {
          label: this.$t('common.date'),
          valueKey: 'timeRange',
          inputType: 'daterange',
          keyList: ['startTime', 'endTime']
        },
        role: {
          label: this.$t('sfe.pattenkpi.role'),
          valueKey: 'role'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.planandtasklist'),
          apiUrl: '/protected/pc/report/planTask/export'
        }
      };
    },
    tableDom: function tableDom() {
      var ruleDataList = this.createRuleDataList();
      return (0, _objectSpread2.default)({
        srCode: {
          label: this.$t('sfe.pattenkpi.srId')
        },
        srName: {
          label: this.$t('sfe.pattenkpi.srName')
        },
        role: {
          label: this.$t('sfe.pattenkpi.role')
        }
      }, ruleDataList);
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/pc/report/planTask/list'
      };
    }
  },
  methods: {
    createRuleDataList: function createRuleDataList() {
      var _this = this;
      // const number9 = new Array(9).toString().split(',').map((t, i) => i + 1)
      // const number9List = {}
      // let keys = []
      // number9.forEach(m => {
      //   if (Number(m) === 1) {
      //     keys = ['PlanCount', 'PlanCountMix', 'TaskCount', 'TaskCountMix', 'PlanTime', 'PlanTimeMix', 'TaskTime', 'TaskTimeMix']
      //   } else if (Number(m) === 2) {
      //     keys = ['PlanCount', 'PlanTime']
      //   } else {
      //     keys = ['PlanCount', 'TaskCount', 'PlanTime', 'TaskTime']
      //   }
      //   // 遍历keys生成数据
      //   keys.forEach(t => {
      //     const propKey = `a0${m}${t}`
      //     number9List[propKey] = { label: this.$t(`sfe.planAndTaskReport.listTable.${propKey}`), isCommasNumber: true }
      //   })
      // })

      // 修改展示顺序
      var number9List = {};
      var typeTask = 'Task';
      var typePlan = 'Plan';
      function generateTypeList(type) {
        return ['a01' + type + 'Count', 'a01' + type + 'CountMix', 'a01' + type + 'Time', 'a01' + type + 'TimeMix', 'a07' + type + 'Count', 'a07' + type + 'Time', 'a05' + type + 'Count', 'a05' + type + 'Time', 'a06' + type + 'Count', 'a06' + type + 'Time', 'a03' + type + 'Count', 'a03' + type + 'Time', 'a04' + type + 'Count', 'a04' + type + 'Time', 'a08' + type + 'Count', 'a08' + type + 'Time', 'a09' + type + 'Count', 'a09' + type + 'Time'
        // 'a13' + type + 'Count',
        // 'a13' + type + 'Time',
        // 'a14' + type + 'Count',
        // 'a14' + type + 'Time',
        // 'a15' + type + 'Count',
        // 'a15' + type + 'Time'
        ];
      }
      var typeTaskList = generateTypeList(typeTask);
      var typePlanList = generateTypeList(typePlan);
      var combinedTypeList = [].concat((0, _toConsumableArray2.default)(typeTaskList), (0, _toConsumableArray2.default)(typePlanList));
      combinedTypeList.forEach(function (t) {
        number9List[t] = {
          label: _this.$t("sfe.planAndTaskReport.listTable.".concat(t)),
          isCommasNumber: true
        };
      });
      return number9List;
    }
  }
};